import _objectWithoutProperties from "/home/runner/work/notes/notes/.layouts/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["icon"];
import React from 'react';
import styled from 'styled-components';
import { COMMON } from './constants';
import sx from './sx';

function Octicon(_ref) {
  var IconComponent = _ref.icon,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(IconComponent, rest);
}

Octicon.displayName = "Octicon";
var StyledOcticon = styled(Octicon).withConfig({
  displayName: "StyledOcticon",
  componentId: "uhnt7w-0"
})(["", " ", ""], COMMON, sx);
StyledOcticon.defaultProps = {
  size: 16
};
export default StyledOcticon;